/*----------------------------------
- MOBILE MENU SECTION
----------------------------------*/

import type { ComponentChildren } from 'preact';

/*----------------------------------
- TYPES
----------------------------------*/

type MobileMenuSectionProps = {
    id: string;
    label: string;
    isOpen: boolean;
    onToggle: () => void;
    testId: string;
    children: ComponentChildren;
};

/*----------------------------------
- COMPONENT
----------------------------------*/

/**
 * One in-place accordion of the mobile menu. The panel is hidden rather than
 * unmounted, so every link it holds is in the server-rendered document for crawlers
 * while staying out of the tab order and the accessibility tree when collapsed.
 */
export default function MobileMenuSection({ id, label, isOpen, onToggle, testId, children }: MobileMenuSectionProps) {
    return (
        <div class="border-b border-[#e6e2da]">
            <button
                type="button"
                onClick={onToggle}
                aria-expanded={isOpen}
                aria-controls={id}
                data-testid={testId}
                class="flex w-full items-center justify-between gap-3 px-1 py-[18px] text-left"
            >
                <span class="text-2xl font-semibold leading-[1.1] tracking-[-0.03em]">{label}</span>
                <span
                    aria-hidden="true"
                    class="inline-flex h-[34px] w-[34px] flex-none items-center justify-center rounded-full bg-[#edeae2] text-[22px] leading-none"
                >
                    {isOpen ? '−' : '+'}
                </span>
            </button>
            <div id={id} hidden={!isOpen} class="pb-[22px]">
                {children}
            </div>
        </div>
    );
}
